// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.admin-header {
  position: fixed;
  top: 0;
  right: 0;
  height: 70px;
  background: white;
  border-bottom: 1px solid #e5e7eb;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 2rem;
  z-index: 999;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  transition: left 0.3s ease, width 0.3s ease;
}

.admin-header.sidebar-open {
  left: 280px;
  width: calc(100% - 280px);
}

.admin-header.sidebar-closed {
  left: 70px;
  width: calc(100% - 70px);
}

.header-left {
  display: flex;
  align-items: center;
  gap: 1rem;
}

.sidebar-toggle-btn {
  background: none;
  border: none;
  padding: 0.5rem;
  cursor: pointer;
  border-radius: 0.375rem;
  transition: background-color 0.2s;
}

.sidebar-toggle-btn:hover {
  background: #f3f4f6;
}

.hamburger {
  display: flex;
  flex-direction: column;
  gap: 3px;
}

.hamburger span {
  width: 20px;
  height: 2px;
  background: #374151;
  transition: all 0.3s;
}

.breadcrumb {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  color: #6b7280;
  font-size: 0.875rem;
}

.breadcrumb-item {
  color: #6b7280;
}

.breadcrumb-separator {
  color: #d1d5db;
}

.breadcrumb-current {
  color: #374151;
  font-weight: 500;
}

.header-right {
  display: flex;
  align-items: center;
  gap: 1rem;
}

.search-container {
  position: relative;
  display: flex;
  align-items: center;
}

.search-input {
  width: 300px;
  padding: 0.75rem 1rem;
  border: 1px solid #d1d5db;
  border-radius: 0.5rem;
  font-size: 0.875rem;
  transition: border-color 0.2s;
}

.search-input:focus {
  outline: none;
  border-color: #3b82f6;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
}

.search-btn {
  position: absolute;
  right: 0.5rem;
  background: none;
  border: none;
  padding: 0.5rem;
  cursor: pointer;
  border-radius: 0.25rem;
  transition: background-color 0.2s;
}

.search-btn:hover {
  background: #f3f4f6;
}

.notifications {
  position: relative;
}

.notification-btn {
  background: none;
  border: none;
  padding: 0.75rem;
  cursor: pointer;
  border-radius: 0.5rem;
  transition: background-color 0.2s;
  font-size: 1.25rem;
  position: relative;
}

.notification-btn:hover {
  background: #f3f4f6;
}

.notification-badge {
  position: absolute;
  top: 0.25rem;
  right: 0.25rem;
  background: #ef4444;
  color: white;
  font-size: 0.75rem;
  padding: 0.125rem 0.375rem;
  border-radius: 9999px;
  min-width: 1.25rem;
  text-align: center;
}

.user-menu {
  position: relative;
}

.user-btn {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  background: none;
  border: none;
  padding: 0.5rem;
  cursor: pointer;
  border-radius: 0.5rem;
  transition: background-color 0.2s;
}

.user-btn:hover {
  background: #f3f4f6;
}

.user-avatar {
  width: 2.5rem;
  height: 2.5rem;
  background: linear-gradient(135deg, #3b82f6, #8b5cf6);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.25rem;
  color: white;
  flex-shrink: 0;
}

.user-avatar-img {
  width: 2.5rem;
  height: 2.5rem;
  border-radius: 50%;
  object-fit: cover;
  border: 2px solid #e2e8f0;
  flex-shrink: 0;
}

.user-info {
  text-align: left;
}

.user-name {
  font-weight: 600;
  font-size: 0.875rem;
  color: #374151;
}

.user-role {
  font-size: 0.75rem;
  color: #6b7280;
}

.dropdown-arrow {
  font-size: 0.75rem;
  color: #6b7280;
  transition: transform 0.2s;
}

.user-menu:hover .dropdown-arrow {
  transform: rotate(180deg);
}

.user-dropdown {
  position: absolute;
  top: 100%;
  right: 0;
  background: white;
  border: 1px solid #e5e7eb;
  border-radius: 0.5rem;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.1);
  min-width: 200px;
  z-index: 1000;
  margin-top: 0.5rem;
}

.dropdown-item {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding: 0.75rem 1rem;
  cursor: pointer;
  transition: background-color 0.2s;
  font-size: 0.875rem;
  color: #374151;
}

.dropdown-item:hover {
  background: #f9fafb;
}

.dropdown-item.logout {
  color: #ef4444;
}

.dropdown-item.logout:hover {
  background: #fef2f2;
}

.dropdown-icon {
  font-size: 1rem;
}

.dropdown-divider {
  height: 1px;
  background: #e5e7eb;
  margin: 0.5rem 0;
}

/* Responsive */
@media (max-width: 768px) {
  .admin-header {
    left: 0 !important;
    width: 100% !important;
  }
  
  .admin-header {
    padding: 0 1rem;
  }
  
  .search-input {
    width: 200px;
  }
  
  .breadcrumb {
    display: none;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/admin/Header/Header.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,MAAM;EACN,QAAQ;EACR,YAAY;EACZ,iBAAiB;EACjB,gCAAgC;EAChC,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;EACf,YAAY;EACZ,wCAAwC;EACxC,2CAA2C;AAC7C;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,UAAU;EACV,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,uBAAuB;EACvB,iCAAiC;AACnC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,WAAW;EACX,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,qBAAqB;EACrB,yBAAyB;EACzB,qBAAqB;EACrB,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,sBAAsB;EACtB,iCAAiC;AACnC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,qBAAqB;EACrB,iCAAiC;EACjC,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,cAAc;EACd,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,0BAA0B;EAC1B,qBAAqB;EACrB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,qBAAqB;EACrB,iCAAiC;AACnC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,cAAc;EACd,qDAAqD;EACrD,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,cAAc;EACd,kBAAkB;EAClB,iBAAiB;EACjB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,iBAAiB;EACjB,yBAAyB;EACzB,qBAAqB;EACrB,0CAA0C;EAC1C,gBAAgB;EAChB,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,qBAAqB;EACrB,eAAe;EACf,iCAAiC;EACjC,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA,eAAe;AACf;EACE;IACE,kBAAkB;IAClB,sBAAsB;EACxB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,aAAa;EACf;AACF","sourcesContent":[".admin-header {\n  position: fixed;\n  top: 0;\n  right: 0;\n  height: 70px;\n  background: white;\n  border-bottom: 1px solid #e5e7eb;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 0 2rem;\n  z-index: 999;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\n  transition: left 0.3s ease, width 0.3s ease;\n}\n\n.admin-header.sidebar-open {\n  left: 280px;\n  width: calc(100% - 280px);\n}\n\n.admin-header.sidebar-closed {\n  left: 70px;\n  width: calc(100% - 70px);\n}\n\n.header-left {\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n}\n\n.sidebar-toggle-btn {\n  background: none;\n  border: none;\n  padding: 0.5rem;\n  cursor: pointer;\n  border-radius: 0.375rem;\n  transition: background-color 0.2s;\n}\n\n.sidebar-toggle-btn:hover {\n  background: #f3f4f6;\n}\n\n.hamburger {\n  display: flex;\n  flex-direction: column;\n  gap: 3px;\n}\n\n.hamburger span {\n  width: 20px;\n  height: 2px;\n  background: #374151;\n  transition: all 0.3s;\n}\n\n.breadcrumb {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  color: #6b7280;\n  font-size: 0.875rem;\n}\n\n.breadcrumb-item {\n  color: #6b7280;\n}\n\n.breadcrumb-separator {\n  color: #d1d5db;\n}\n\n.breadcrumb-current {\n  color: #374151;\n  font-weight: 500;\n}\n\n.header-right {\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n}\n\n.search-container {\n  position: relative;\n  display: flex;\n  align-items: center;\n}\n\n.search-input {\n  width: 300px;\n  padding: 0.75rem 1rem;\n  border: 1px solid #d1d5db;\n  border-radius: 0.5rem;\n  font-size: 0.875rem;\n  transition: border-color 0.2s;\n}\n\n.search-input:focus {\n  outline: none;\n  border-color: #3b82f6;\n  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);\n}\n\n.search-btn {\n  position: absolute;\n  right: 0.5rem;\n  background: none;\n  border: none;\n  padding: 0.5rem;\n  cursor: pointer;\n  border-radius: 0.25rem;\n  transition: background-color 0.2s;\n}\n\n.search-btn:hover {\n  background: #f3f4f6;\n}\n\n.notifications {\n  position: relative;\n}\n\n.notification-btn {\n  background: none;\n  border: none;\n  padding: 0.75rem;\n  cursor: pointer;\n  border-radius: 0.5rem;\n  transition: background-color 0.2s;\n  font-size: 1.25rem;\n  position: relative;\n}\n\n.notification-btn:hover {\n  background: #f3f4f6;\n}\n\n.notification-badge {\n  position: absolute;\n  top: 0.25rem;\n  right: 0.25rem;\n  background: #ef4444;\n  color: white;\n  font-size: 0.75rem;\n  padding: 0.125rem 0.375rem;\n  border-radius: 9999px;\n  min-width: 1.25rem;\n  text-align: center;\n}\n\n.user-menu {\n  position: relative;\n}\n\n.user-btn {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n  background: none;\n  border: none;\n  padding: 0.5rem;\n  cursor: pointer;\n  border-radius: 0.5rem;\n  transition: background-color 0.2s;\n}\n\n.user-btn:hover {\n  background: #f3f4f6;\n}\n\n.user-avatar {\n  width: 2.5rem;\n  height: 2.5rem;\n  background: linear-gradient(135deg, #3b82f6, #8b5cf6);\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 1.25rem;\n  color: white;\n  flex-shrink: 0;\n}\n\n.user-avatar-img {\n  width: 2.5rem;\n  height: 2.5rem;\n  border-radius: 50%;\n  object-fit: cover;\n  border: 2px solid #e2e8f0;\n  flex-shrink: 0;\n}\n\n.user-info {\n  text-align: left;\n}\n\n.user-name {\n  font-weight: 600;\n  font-size: 0.875rem;\n  color: #374151;\n}\n\n.user-role {\n  font-size: 0.75rem;\n  color: #6b7280;\n}\n\n.dropdown-arrow {\n  font-size: 0.75rem;\n  color: #6b7280;\n  transition: transform 0.2s;\n}\n\n.user-menu:hover .dropdown-arrow {\n  transform: rotate(180deg);\n}\n\n.user-dropdown {\n  position: absolute;\n  top: 100%;\n  right: 0;\n  background: white;\n  border: 1px solid #e5e7eb;\n  border-radius: 0.5rem;\n  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.1);\n  min-width: 200px;\n  z-index: 1000;\n  margin-top: 0.5rem;\n}\n\n.dropdown-item {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n  padding: 0.75rem 1rem;\n  cursor: pointer;\n  transition: background-color 0.2s;\n  font-size: 0.875rem;\n  color: #374151;\n}\n\n.dropdown-item:hover {\n  background: #f9fafb;\n}\n\n.dropdown-item.logout {\n  color: #ef4444;\n}\n\n.dropdown-item.logout:hover {\n  background: #fef2f2;\n}\n\n.dropdown-icon {\n  font-size: 1rem;\n}\n\n.dropdown-divider {\n  height: 1px;\n  background: #e5e7eb;\n  margin: 0.5rem 0;\n}\n\n/* Responsive */\n@media (max-width: 768px) {\n  .admin-header {\n    left: 0 !important;\n    width: 100% !important;\n  }\n  \n  .admin-header {\n    padding: 0 1rem;\n  }\n  \n  .search-input {\n    width: 200px;\n  }\n  \n  .breadcrumb {\n    display: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
